// extracted by mini-css-extract-plugin
module.exports = {"fields":"Recipients_fields__2xuAy","field":"Recipients_field__2_Vsa","divider":"Recipients_divider__1UlIB","minus":"Recipients_minus__1dtzx"};